var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},_vm._l((_vm.infoList),function(item){return _c('div',{key:item.key,staticClass:"info"},[_c('div',{staticStyle:{"width":"110px"}},[_vm._v(_vm._s(item.label))]),_c('div',[_vm._v(_vm._s(item.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }